__turbopack_context__.v({
  "__top": "ThirdScreenInfra-module-scss-module__mSpdLa____top",
  "secondScreenImgTwo": "ThirdScreenInfra-module-scss-module__mSpdLa__secondScreenImgTwo",
  "thirdScreenContainer": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenContainer",
  "thirdScreenDescription": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenDescription",
  "thirdScreenGradient": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenGradient",
  "thirdScreenGradientBottom": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenGradientBottom",
  "thirdScreenGradientBottom_2": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenGradientBottom_2",
  "thirdScreenImg": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenImg",
  "thirdScreenInfoBox": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenInfoBox",
  "thirdScreenInfoContainer": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenInfoContainer",
  "thirdScreenInfoDescrip": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenInfoDescrip",
  "thirdScreenInfoTitle": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenInfoTitle",
  "thirdScreenSvg": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenSvg",
  "thirdScreenSvg_two": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenSvg_two",
  "thirdScreenTitle": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenTitle",
  "thirdScreenTitleMobile": "ThirdScreenInfra-module-scss-module__mSpdLa__thirdScreenTitleMobile",
});
